var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiIcon = function SvgAiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9a9 9 0 0 0 9 9v-1a8 8 0 1 1 8-8h1A9 9 0 1 0 0 9Z",
    fill: "url(#AiIcon_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.06 10 13 7.06A.75.75 0 1 0 11.94 6L8 9.94 6.06 8A.75.75 0 0 0 5 9.06l3 3 2-2V10h.06Z",
    fill: "url(#AiIcon_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11a.5.5 0 0 1 .49.402l.108.539a2.5 2.5 0 0 0 1.961 1.96l.54.109a.5.5 0 0 1 0 .98l-.54.108a2.5 2.5 0 0 0-1.96 1.961l-.109.54a.5.5 0 0 1-.98 0l-.108-.54a2.5 2.5 0 0 0-1.961-1.96l-.54-.109a.5.5 0 0 1 0-.98l.54-.108a2.5 2.5 0 0 0 1.96-1.961l.109-.54A.5.5 0 0 1 14.5 11Zm0 2.168a3.504 3.504 0 0 1-1.332 1.332 3.504 3.504 0 0 1 1.332 1.332 3.504 3.504 0 0 1 1.332-1.332 3.504 3.504 0 0 1-1.332-1.332Z",
    fill: "url(#AiIcon_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AiIcon_svg__a",
    x1: 0,
    y1: 9,
    x2: 18,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0021FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#116DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FF2AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AiIcon_svg__b",
    x1: 0,
    y1: 9,
    x2: 18,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0021FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#116DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FF2AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AiIcon_svg__c",
    x1: 0,
    y1: 9,
    x2: 18,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0021FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#116DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FF2AE"
  })))));
};
export default SvgAiIcon;